import react, { useEffect, useState } from "react";
import { useRef } from "react";
import InputPopup from "../../UI/InputPopup/InputPopup";
import DropdownRadioMultiSelect from "../../components/controls/DropdownRadioMultiSelect/DropdownRadioMultiSelect";
import styles from "./TemplateMonitorRow.module.css";
import gStyles from "./TemplateMonitorGlobalStyles.module.css";
import Tooltip from "../../UI/Tooltip/Tooltip";

const TemplateMonitorRowAttributes = (props) => {
  const [displayButtons, setDisplayButtons] = useState(false);
  const [title, setTitle] = useState(props.title);
  const [tooltip, setTooltip] = useState(props.tooltip);
  const [tooltipIsVisible, setTooltipIsVisible] = useState(false);
  const [initialTooltipValue, setInitialTooltipValue] = useState(props.tooltip);
  // const [questionType, setQuestionType] = useState(props.questionType);
  // const [questionTypeSelected, setQuestionTypeSelected] = useState(false);
  // const [displayQuestionTypeButtons, setDisplayQuestionTypeButtons] = useState(false);

  // Input Popup
  const [inputPopupShow, setInputPopupShow] = useState(false);
  const tooltipCell = useRef(null)

  // const {
  //   getArrowProps,
  //   getTooltipProps,
  //   setTooltipRef,
  //   setTriggerRef,
  //   visible,
  // } = usePopperTooltip({
  //   interactive: true,
  //   // delayHide: 40
  // });

  useEffect(() => {
    setTitle(props.title);
    setTooltip(props.tooltip);
  }, [props]);

  // const buttonStyle = `${styles.Button} ${styles.checkedButton}`;
  let titleStyle = "";
  let type = props.type;
  let pos = props.pos; // position/index of row in the array
  if (type === "principio") {
    titleStyle = styles.principio;
  }
  else if (type === "requisito") {
    titleStyle = styles.requisito;
  }
  else if (type === "ambito") {
    titleStyle = styles.ambito;
  }

  const changeTextareaHeight = (e) => {
    e.target.style.height = "inherit";
    e.target.style.height = `${e.target.scrollHeight}px`;
  };

  const validateFraction = (input) => {
    const value = input;

    const regex = /^(?:$|\d+\.\d+|\d+\.?)$/;

    return regex.test(value) || value === '';
  }

  const saveTooltipPopupContent = (content) => {
    props.updateTooltipHandler(pos, content);
    setInputPopupShow(false);
  }

  // const showQuestionTypeButtonsHandler = () => {
  //   setDisplayQuestionTypeButtons(true);
  // };

  // const hideQuestionTypeButtonsHandler = () => {
  //   setDisplayQuestionTypeButtons(false);
  // };

  // const determineQuestionType = (questionT) => {
  //   setDisplayQuestionTypeButtons(false);
  //   setQuestionTypeSelected(true);
  //   props.addQuestion(pos, questionT);
  // };

  const addAmbitoButton = (
    <button
      onClick={
        () => { props.addAmbito(pos) }
      }
      className={`${styles.addQuestionButton} ${displayButtons ? "visible" : "invisible"}`}
    ></button>
  );

  const addQuestionButton = (
    <button
      onClick={
        () => { props.addQuestion(pos) }
      }
      className={`${styles.addQuestionButton} ${displayButtons ? "visible" : "invisible"}`}
    ></button>
  );

  const questionsButtons = (
    <div
      className={`${styles.add_remove_question} overflow-visible p-0`}
    >
      {addQuestionButton}
      {/* Handle hiding remove button in quantitative if less than three */}
      <button
        // onClick={() => props.removeQuestion(pos)}
        onClick={() => props.modalDataHandler("Delete question", "Permanently remove question?", 'confirmation', () => props.removeQuestion(pos))}
        className={`${styles.removeQuestionButton} ${displayButtons ? "visible" : "invisible"}`}
      ></button>
    </div>
  );

  const ambitoButtons = (
    <div
      className={`${props.deletable && props.isQualitative ? styles.add_remove_question : styles.add_question} overflow-visible p-0`}
    >
      {props.isQualitative && addQuestionButton}
      {props.deletable ? <button
        onClick={() => props.modalDataHandler("Delete question", "Permanently remove ambito?", 'confirmation', () => props.removeAmbito(pos))}
        className={`${styles.removeQuestionButton} ${displayButtons ? "visible" : "invisible"}`}
      ></button> : null}
    </div>
  );

  const requisitoButton = (
    <div
      className={`${styles.add_question} overflow-visible p-0`}
    >
      {addAmbitoButton}
    </div>
  );

  const elementDropdownArrow = (
    <div
      className={`${styles.dropdownArrowContainer} overflow-visible p-0`}
    >
      <button
        onClick={
          () => {
            props.collapseElement(pos, !props.isCollapsed)
          }
        }
        className={`${styles.dropdownArrow} ${props.isCollapsed ? styles.down : styles.up} ${displayButtons ? "visible" : "invisible"}`}
      ></button>
    </div>
  );

  // (
  //   <div
  //     ref={setTooltipRef}
  //     {...getTooltipProps({ className: `${styles.infoTooltip} tooltip-container` })}
  //   >
  //       {/* for the css classes used go to node_modules\react-popper-tooltip\dist\styles.css  */}
  //     <div {...getArrowProps({ className: `${styles.tooltipArrow} tooltip-arrow` })} />
  //     {tooltip} {(initialTooltipValue !== tooltip) /* && ("(not saved)") */}
  //   </div>
  // )

  // const questionTypeButtons = (
  //   <div
  //     onBlur={hideQuestionTypeButtonsHandler}
  //     className={`${styles.questionTypeButtons} d-flex flex-column justify-content-center align-items-center`}
  //     disabled={questionTypeSelected}
  //   >
  //     <p className="mb-1" style={{ textAlign: "center", color: "black" }}>
  //       Choose question type:
  //     </p>
  //     <div className={`d-flex justify-content-center align-items-center`}>
  //       <button
  //         onClick={() => determineQuestionType("qualitative")}
  //         className={styles.qualitativeButton}
  //       >
  //         qualitative
  //       </button>
  //       <button
  //         onClick={() => determineQuestionType("quantitative")}
  //         className={styles.quantitativeButton}
  //       >
  //         quantitative
  //       </button>
  //     </div>
  //   </div>
  // );

  // Check whether the tooltip popup needs to be displayed above the clicked Add/Edit tooltip button
  let isCloseToBottomOfViewport = false;
  if (tooltipCell.current) {
    let viewportHeight = window.innerHeight;
    // console.log("tooltipCell, id ", props.displayId, tooltipCell.current.getBoundingClientRect());
    const bottom = tooltipCell.current.getBoundingClientRect().bottom;
    const submitButtonContainerHeight = 51; // the Submit button container height is specified in the CSS file of this component
    const tooltipPopupHeight = 110;
    if (viewportHeight - bottom - submitButtonContainerHeight < tooltipPopupHeight) {
      isCloseToBottomOfViewport = true;
    }
  }

  return (
    <tr onMouseEnter={() => setDisplayButtons(true)} onMouseLeave={() => setDisplayButtons(false)}>
      {/* Element id & title */}
      <td
        className={`
          ${titleStyle} ${styles.questionsWidth} 
          ${!type && props.invalidInputs && Object.values(props.invalidInputs).filter(val => val === true).length > 0 ? styles.invalidInput : ""} 
          ${type === "ambito" && props.invalidInputs && Object.values(props.invalidInputs).filter(val => val === true).length > 0 ? styles.invalidInput : ""} 
          ${type && (styles.cursorPointer + ' ' + styles[`${type}Hover`])} 
          ${props.isCollapsed && type !== "ambito" && (props.hasValidChildren ? styles[`${type}Valid`] : styles[`${type}Invalid`])}
          ${(!type || type === "ambito" && props.isEmpty) ? "px-2" : "p-0"}
          fw-bold text-start position-relative
        `}
        data-tip=""
      >
        {!type && props.isQualitative && questionsButtons}
        {type === "ambito" && ambitoButtons}
        {type && type === "requisito" && requisitoButton}
        {type && type !== "ambito" && type !== "requisito" && elementDropdownArrow /* excluding ambiti because they have the plus button */}
        {!type && (props.isQualitative || props.isEmpty) && (
          <div className="d-flex">
            {(props.type || props.isQualitative) && <div className={`${styles.questionId} pe-2 me-2`}>{props.principioId}.{props.displayId && props.displayId}</div>}
            <textarea
              onKeyDown={changeTextareaHeight}
              placeholder="Type your question here"
              className={`${styles.inputField} fw-bold`}
              value={title}
              onChange={(e) => {
                setTitle(e.target.value);
              }}
              onBlur={() => {
                props.updateQuestionTitle(pos, title);
              }}
            />
          </div>
        )}
        {!type && !props.isQualitative && !props.isEmpty && <p
          className="m-0 p-1 px-2 h-100 d-flex align-items-center justify-content-between fw-bold"
        >{title}</p>}
        {type === "ambito" && props.isEmpty && <div className="d-flex">
          <textarea
            onKeyDown={changeTextareaHeight}
            placeholder="Type your ambito here"
            className={`${styles.inputField} fw-bold`}
            value={title}
            onChange={(e) => {
              setTitle(e.target.value);
            }}
            onBlur={() => {
              props.updateAmbitoTitle(pos, title);
            }}
          />
        </div>}
        {type && !props.isEmpty && (
          <p
            className="m-0 p-1 px-2 h-100 d-flex align-items-center justify-content-between"
            onClick={() => {
              if (type && type !== "ambito") {
                props.collapseElement(pos, !props.isCollapsed);
              }
            }}
          >{title} {type === "ambito" && !props.isQualitative && <input className="mx-1" checked={props.isActive} type="checkbox" onChange={(e) => props.toggleAmbito(pos, e.target.checked)} />}
          </p>
        )}
      </td>
      <td className={styles.whiteSpaceHeader}></td>
      {/* Main Attributes Dropdown */}
      {!type && (
        <td
          className={`${styles.mainAttrs} ${!props.mainAttrs && styles.disabledAttrBtn} ${props.isQualitative && props.invalidInputs.mainAttributeIsUndefined ? styles.invalidInput : ""}`}
        > {/*colSpan={2}*/}
          <div className="d-flex justify-content-center align-items-center w-100 h-100">
            {props.mainAttrs && <DropdownRadioMultiSelect
              data={props.mainAttrs}
              name={"mainAttributes"}
              emptyListMessage={"No options selected"}
              // defaultValue={values.controlFunctionId}
              changed={props.changeMainAttribute}
              listId={pos}
            >
            </DropdownRadioMultiSelect>}
          </div>
        </td>
      )}
      {type && <td className={`${styles.DropdownRadioMultiSelect} ${titleStyle}`}></td>}
      {/* Tooltip cell*/}
      <td ref={tooltipCell} className={`${!props.isQualitative && !type ? styles.disabledAttrBtn : ''} ${gStyles.tooltip} ${titleStyle}`}>
        <div
          onMouseEnter={() => setTooltipIsVisible(true)}
          onMouseLeave={() => setTooltipIsVisible(false)}
          className="position-relative d-flex justify-content-center align-items-center w-100 h-100"
        >
          {tooltip && <Tooltip text={tooltip} show={tooltipIsVisible} />}
          {!(!props.isQualitative && !type) && <button
            // className={`${styles[props.tooltip ? "addTooltipButton" : "addTooltipButtonEmpty"]}`}
            className={`
              ${styles.tooltipButton} 
              ${!type ?
                (styles[tooltip ? "qstEditTooltip" : "qstAddTooltip"]) :
                (styles[tooltip ? "editTooltip" : "addTooltip"])
              }`
            }
            onClick={() => {
              setInputPopupShow(true);
              setTooltipIsVisible(false);
            }}
          >{tooltip ? "Edit" : "Add"}</button>}
          {inputPopupShow && <InputPopup content={tooltip} maxLength={4000} placeholder={"Type the description here..."} positionAboveParent={isCloseToBottomOfViewport} saveContent={saveTooltipPopupContent} />}
        </div>
      </td>


      {/* {type && <td className={`${styles.tooltipWidth} ${titleStyle}`}></td>} */}

      {/* Drivers */}
      {!type &&
        (props.isQualitative ? [...props.attrDrivers, "poor", "unsatisfactory", "good"] : ["completeness", "accuracy", "effectiveness", "reliability", "poor", "unsatisfactory", "good"]).map(
          (
            driver // question element
          ) => (
            <td
              className={`${gStyles.opScopeWidth} ${driver.value === undefined && styles.disabledAttrBtn} ${!type && props.invalidInputs.allAttrDriversAreUnckecked
                ? styles.invalidInput
                : ""
                } ${type === "ambito" && Object.values(props.invalidInputs).filter(val => val === true).length > 0
                  ? styles.invalidInput
                  : ""
                }`}
              key={pos + "-" + driver.name ? driver.name : driver}
            >
              {props.isQualitative && <button
                // the value of the field determines if the checked symbol is shown
                className={
                  `${driver.value ? styles.checkedButton : styles.uncheckedButton} `
                }
                // return the operational scope field which is on string format
                disabled={driver.disabled}
                onClick={() => {
                  let updatedDriverValue;
                  if (driver.value === 0) {
                    updatedDriverValue = 1;
                  } else {
                    updatedDriverValue = 0;
                  }
                  props.changeAttrDriver(pos, driver.name, updatedDriverValue);
                }}
              ></button>}
            </td>
          )
        )}
      {type &&
        ["", "", "", "", "poor", "unsatisfactory", "good"].map(
          (
            col,
            index // non-question elements (principi, reqiusiti, ambiti)
          ) => (
            <td
              className={`${gStyles.opScopeWidth} ${titleStyle} ${type === "ambito" && !props.isQualitative && ["poor", "unsatisfactory", "good"].some(d => !(/^(?:\d+|\d+\.\d+)$/.test(props[d]))) ? styles.invalidInput : ''}`}
              key={"driverHeader" + index}
            >{!props.isQualitative && col !== "" && type === "ambito" && <div className={styles.qntDrivers}>
              <textarea
                onChange={(e) => validateFraction(e.target.value) ? props.changeQntAttrDriver(pos, col, e.target.value) : null}
                className={`${styles.inputField} fw-bold text-center`}
                value={props[col]}
                disabled={!props.isActive}
              />
              {/* <input type="number" onChange={(e) => props.changeQntAttrDriver(pos, col, e.target.value)} value={props[col]} /> */}
            </div>}</td>
          )
        )}
    </tr>
  );
};

export default TemplateMonitorRowAttributes;
